import { JSX } from 'react'

import { HStack, Icon, Stat } from '@chakra-ui/react'

import { RxAccessibility } from 'react-icons/rx'




export default function
(
	props: {
		online: boolean
		signed: boolean

	},

)
:	JSX.Element
{
	let value = '尚未签约'
	let color = 'fg.error'

	if (props.signed)
	{
		value = '已离职'
		color = 'fg.warning'

	}

	if (props.online)
	{
		value = '在职中'
		color = 'fg.success'

	}

	return (
		<Stat.Root w="xs" p="4" rounded="md" borderWidth="1px">
			<HStack justify="space-between">
				<Stat.Label>签约状态</Stat.Label>

				<Icon color={color}>
					<RxAccessibility />

				</Icon>

			</HStack>

			<Stat.ValueText>{value}</Stat.ValueText>

		</Stat.Root>

	)

}
